import { Component, inject, Inject, model, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { SnackBarService } from '../../../services/snack-bar-service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SessionService } from '../../../services/session-service';
import { EligibilitySession } from '../../../models/eligibility-session';

function atLeastOneRequiredValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const group = control as FormGroup;
    const hasValue = Object.values(group.controls).some(c => !!c.value);
    return hasValue ? null : { atLeastOneRequired: true };
  };
}

@Component({
  selector: 'app-import-sites-from-manual-input-modal-component',
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule
  ],
  templateUrl: './import-sites-from-manual-input-modal-component.html',
  styleUrl: './import-sites-from-manual-input-modal-component.css',
})
export class ImportSitesFromManualInputModalComponent {
  readonly EMPTY_SITE = { id: null, name: null, reference: null, sourceAddress: {} };

  private formBuilder = inject(FormBuilder);

  readonly isCreatingSite = signal<boolean>(false);
  readonly sites = model<any[]>([]);

  site = this.formBuilder.group({
    name: [null],
    reference: [null],
    sourceAddress: this.formBuilder.group({
      address: [null],
      coordinates: [null],
      fibre_building_code: [null]
    }, { validators: atLeastOneRequiredValidator() })
  });

  constructor( 
    private readonly dialogRef: MatDialogRef<ImportSitesFromManualInputModalComponent>,
    private readonly snackBar: SnackBarService,
    private sessionService: SessionService,
    @Inject(MAT_DIALOG_DATA) private readonly data: any
  ) { }

  createSite(createAndClose: boolean = true): void {
    if (this.site.invalid) {
      this.site.markAllAsTouched();
      return;
    }

    const sessionCode = this.data.sessionCode;

    if (!sessionCode) {
      this.snackBar.error("Code de session invalide");
      return;
    }

    this.isCreatingSite.set(true);

    this.sessionService.createSessionSite(sessionCode, this.site.getRawValue()).subscribe({
      next: (site) => {
        this.snackBar.success("Site crée !");

        if (createAndClose) {
          this.dialogRef.close(site);
        } else {
          // Reset form
          this.isCreatingSite.set(false);
          this.site.reset();
        }
      },
      error: () => {
        this.snackBar.error("Erreur rencontrée lors de la création du site.");
        this.isCreatingSite.set(false);
      }
    })
  }
}
